<template>
  <div class="modal fade" tabindex="-1" id="callModal"  aria-labelledby="callModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center small p-4">
          <i class="fa fa-4x fa-info-circle text-primary m-b15"></i>
          <h4 class="">{{$t('call')}}?</h4>
          <p>{{ $t('call_text_one') }}<br> {{$t('call_text_two')}}</p>
          <div class="text-center m-t20">
            <a href="javascrpit:void(0);" data-bs-dismiss="modal" class="btn btn-sm btn-light m-r10">{{$t('cancel')}}</a>
            <a v-if="!table" @click.prevent="goToScanner"  class="btn btn-sm btn-primary">{{ $t('calling') }}</a>
            <a v-else @click.prevent="callServer"  class="btn btn-sm btn-primary">
              <span v-if="calling" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ $t('calling') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {toast} from "vue3-toastify";

const store = useStore()
const router = useRouter();
const calling = ref(false)
const table = computed(() => store.getters['contact/table'])


function goToScanner(){
  // eslint-disable-next-line no-undef
  $('#callModal').modal('hide')
  router.push({name:'call-server-page'})
}

function callServer(){

  calling.value = true
  store.dispatch('contact/callServer', {table_id: table.value})
      .then(response => {
        console.log(response)
        toast.success('Un(e) serveur(se) viendra dans quelques minutes')
      })
      .finally(() => {
        calling.value = false
        // eslint-disable-next-line no-undef
        $('#callModal').modal('hide')
      })
}
</script>

<style scoped>
.modal{
  width: 88%;
  align-self: center;
  left: 6%;
  right: 6%;
}
</style>